import { useNotificationStore } from '@/legacy/store/modules/notification'
import { NotificationType } from '@/legacy/types/notifications'
import { KnowledgeBaseLlmResponse } from '@/libs/features/llm/types'
import { AskSopInputForm } from './AskSOPModalInputs/types'
import { useKnowledgeBaseLlmApi } from './store'

/**
 *
 * @param data
 * @param debug
 */
export async function getKnowledgeBaseResponse(
  data: AskSopInputForm,
  debug: boolean
): Promise<KnowledgeBaseLlmResponse | undefined> {
  const llmApi = useKnowledgeBaseLlmApi()

  try {
    return await llmApi.create({
      body: {
        query: data.query,
        userContext: data.userContext,
        model: data.devToolOptions.model,
        temperature: data.devToolOptions.temperature,
        maxResponseTokens: data.devToolOptions.maxResponseTokens,
        debug,
      },
    })
  } catch (err) {
    useNotificationStore().setNotification({
      message: 'Failed to retrieve "Ask Thyme Box" response.',
      type: NotificationType.DANGER,
      error: err as Error,
    })
    throw err
  }
}
